const SESSION_OVEN_CONTENT = {
  NewBowl: 1,
  Second_Use: 2,
  Third_Use: 3,
  UNKNOWN: 0,
};

export default SESSION_OVEN_CONTENT;
